module.exports = __webpack_public_path__ + "img/Screen_7.68269a63.png";